export const global = {
  login: 'Login',
  logout: 'Logout',
  tableShowingToFrom: 'Showing {showing} to {to} from {from}',
  tableSearch: 'Enter keyword...',
  loading: 'Loading...'
}
